export interface MenuRoute {
	href: string;
	relative: boolean;
	text: string;
	icon?: string;
}

export const appointmentMenuRoutes = [
	{
		href: 'appointments',
		relative: false,
		text: 'Home',
		icon: 'home-outline',
	},
	{
		href: 'details',
		relative: true,
		text: 'Details',
		icon: 'eye-outline',
	},
	// {
	// 	href: 'history',
	// relative: true,
	// 	text: 'History',
	// 	icon: 'library-outline',
	// },
	{
		href: 'inventory',
		relative: true,
		text: 'Inventory',
		icon: 'construct-outline',
	},
	// {
	// 	href: 'forms',
	// relative: true,
	// 	text: 'Forms',
	// 	icon: 'document-text-outline',
	// },
	// {
	// 	href: 'contracts',
	// relative: true,
	// 	text: 'Contracts',
	// 	icon: 'documents-outline',
	// },
	{
		href: 'attachments',
		relative: true,
		text: 'Attachments',
		icon: 'document-attach-outline',
	},
	{
		href: 'ticket-notes',
		relative: true,
		text: 'Notes',
		icon: 'receipt-outline',
	},
	// {
	// 	href: 'charges',
	// relative: true,
	// 	text: 'Charges',
	// 	icon: 'cash-outline',
	// },
	// {
	// 	href: 'eta',
	// relative: true,
	// 	text: 'Appointment ETA',
	// 	icon: 'hourglass-outline',
	// },
	// {
	// 	href: 'upsell',
	// relative: true,
	// 	text: 'Upsell',
	// 	icon: 'chevron-up-circle-outline',
	// },
	{
		href: 'clear-codes',
		relative: true,
		text: 'Clear Codes',
		icon: 'cog-outline',
	},
] as MenuRoute[];
